import styled from 'vue3-styled-components';

export const MainBoxSc = styled('div', ['visible'])`
  display: flex;
  position: relative;
  padding: 15px 0px;
  .picker-wh:nth-child(1){
    flex: 1.6;
    ul{
      margin-left: 25%;
    }
  }
  .picker-wh:nth-child(2){
    flex: 1;
  }
  .picker-wh:nth-child(3){
    flex: 1;
  }
  .picker-wh:nth-child(4){
    flex: 1.2;
    ul{
      margin-right: 35%;
    }
  }
  .finish{
    position: absolute;
    top: 0px;
    right: 6%;
    font-weight: 500;
    z-index: 2;
    font-family: 'PingFang SC-Medium', 'PingFang SC', 'Source Han Sans CN-Medium', 'Source Han Sans CN';
    color: #2bc689;
    font-size: 16px;
  }
`;